module.exports = __webpack_public_path__ + "img/stroke-icons.a1c6f89d.svg";